var base = require('notifications/notifications');

Vue.component('spark-notifications', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/notifications/notifications.js